import '../../../../styles/oa.scss';
import React ,{ useState,useEffect} from 'react';
import { useHistory } from 'react-router';
import sysConfig from '@/sysConfig';
import { unreadNumNotice,auditNumLeave } from '../../../../services/saas/oa';
import { getUser } from '../../../../utils';
import func from '@/utils/Func';

const { preRouteUrl } = sysConfig;
function Oa(props) {
  const [leaveAuditNum, setLeaveAuditNum] = useState(0);
  const [newNoticeNum, setNewNoticeNum] = useState(0);
  const [newNoticeTime, setNewNoticeTime] = useState('');
  const [leaveAuditTime, setLeaveAuditTime] = useState('');
  const history = useHistory();
  const { deptId,userId,userType} = getUser()||{};
  //待审核请假数量
  const getWaitAuditLeaveNum = async function () {

    const param = {
      deptId,
      leaveFormStatus:1
    };

    const respActive = await auditNumLeave(param);
    if (respActive&&respActive.success && respActive.data) {
      setLeaveAuditNum(respActive.data.ct);
      setLeaveAuditTime(respActive.data.updateTime);
    }
  };
    //待阅读消息数量
  const getUnReadNoticeNum = async function () {
    const param = {
      userId
    };

    const respActive = await unreadNumNotice(param);
    if (respActive&&respActive.success&&respActive.data) {
      setNewNoticeNum(respActive.data.ct);
      setNewNoticeTime(respActive.data.publishTime);
    }
  };

  useEffect(()=>{
    getWaitAuditLeaveNum();
    getUnReadNoticeNum();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])




  return (
    <div className="oaNav">
      <div className="oaNav-item my-notice" onClick={() => history.push(`${preRouteUrl}/oa/notice`)}>
        <div className="oaNav-item-left">
          <em></em>
          <span>我的通知</span>
        </div>
        {
          newNoticeNum > 0 ? <div className="oaNav-item-right">
                              <span className="time">{func.timeToDif('',newNoticeTime)}</span>
                              <span className="num">{newNoticeNum>99?'99+':newNoticeNum}</span>
                            </div>:null
        }
      </div>

      {
        userType === '5'||userType === '6'?(
          <div>
              <div className="oaNav-item leave-approval" onClick={() => history.push(`${preRouteUrl}/oa/leave`)}>
                <div className="oaNav-item-left">
                  <em></em>
                  <span>请休假审批</span>
                </div>
                {
                  leaveAuditNum > 0 ? <div className="oaNav-item-right">
                                      <span className="time">{func.timeToDif('',leaveAuditTime)}</span>
                                      <span className="num">{leaveAuditNum>99?'99+':leaveAuditNum}</span>
                                    </div>:null
                }
              </div>

              <div className="oaNav-item attendance-report" onClick={() => history.push(`${preRouteUrl}/oa/kqemployee`)}>
                <div className="oaNav-item-left">
                    <em></em>
                    <span>员工考勤报告</span>
                  </div>
                </div>
              </div>
        ):null
      }

    </div>
  );
}

export default Oa;
